@file:OptIn(ExperimentalSerializationApi::class)
package com.gsb.vyapar.bhagya.domain

import com.gsb.vyapar.bhagya.datasource.network.Dto
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class Info(
    val v: Int = 0,
    val d: D = D()
) {
    @Serializable
    data class D(
        val info: Map<String, String> = mapOf()
    )
}

fun Dto.toInfo(): Info {
    return Info(v = v, d = ProtoBuf.decodeFromByteArray<Info.D>(d.decodeBase64Bytes().uncompress(GZIP)))
}

fun Info.toDto(): Dto {
    return Dto(v = v, d = ProtoBuf.encodeToByteArray(d).compress(GZIP).encodeBase64())
}

fun String.decodeInfoString(): Info {
    return try {
        if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
            return Info()
        }
        ProtoBuf.decodeFromByteArray<Info>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        Info()
    }
}

fun Info.encodeInfoString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun Info.getEmail(): String {
    return this.d.info[EMAIL].orEmpty()
}

fun Info.getFb(): String {
    return this.d.info[FACEBOOK].orEmpty()
}

fun Info.getInst(): String {
    return this.d.info[INSTAGRAM].orEmpty()
}

fun Info.getX(): String {
    return this.d.info[X].orEmpty()
}

fun Info.getShare(): String {
    return this.d.info[SHARE].orEmpty()
}

fun Info.getAbout(): String {
    return this.d.info[ABOUT].orEmpty()
}

fun Info.getSupport(): String {
    return this.d.info[SUPPORT].orEmpty()
}

fun Info.getTerms(): String {
    return this.d.info[TERMS].orEmpty()
}

fun Info.getPrivacy(): String {
    return this.d.info[PRIVACY].orEmpty()
}

fun Info.getUpi(): String {
    return this.d.info[UPI].orEmpty()
}

fun Info.getOtp(): String {
    return this.d.info[OTP].orEmpty()
}

fun Info.getMobile(): String {
    return this.d.info[MOBILE].orEmpty()
}

fun Info.getWebsite(): String {
    return this.d.info[WEBSITE].orEmpty()
}

fun Info.getAndroid(): String {
    return this.d.info[ANDROID].orEmpty()
}

fun Info.getIos(): String {
    return this.d.info[IOS].orEmpty()
}

fun Info.getMqttUrl(): String {
    return this.d.info[MQTT_URL].orEmpty()
}

fun Info.getMqttPort(): String {
    return this.d.info[MQTT_PORT].orEmpty()
}

fun Info.getMqttWebPort(): String {
    return this.d.info[MQTT_WEB_PORT].orEmpty()
}

fun Info.getWebApp(): String {
    return this.d.info[WEB_APP].orEmpty()
}

fun Info.getAppVersion(): String {
    return this.d.info[VERSION].orEmpty()
}

fun Info.getMqttUserName(): String {
    return this.d.info[MQTT_USER_NAME].orEmpty()
}

fun Info.getMqttPassword(): String {
    return this.d.info[MQTT_PASSWORD].orEmpty()
}

fun Info.getMqttCertificate(): String {
    return this.d.info[MQTT_CERTIFICATE].orEmpty()
}